import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

interface SortableTableHeaderProps<T extends string> {
  label: string;
  column: T;
  currentSort: T;
  sortDir: 'asc' | 'desc';
  onSort: (column: T) => void;
  align?: 'left' | 'right' | 'center';
}

export default function SortableTableHeader<T extends string>({
  label,
  column,
  currentSort,
  sortDir,
  onSort,
  align = 'left',
}: SortableTableHeaderProps<T>) {
  const active = currentSort === column;
  const alignClass = align === 'right' ? 'justify-end ml-auto' : align === 'center' ? 'justify-center mx-auto' : '';

  return (
    <th
      className={`px-4 py-3 text-sm font-bold text-gray-900 bg-gray-50 uppercase tracking-wide sticky top-0 z-20 shadow-[inset_0_-1px_0_0_rgb(229,231,235)] ${
        align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left'
      }`}
    >
      <button
        type="button"
        onClick={() => onSort(column)}
        className={`inline-flex items-center gap-1 hover:text-gray-800 ${alignClass}`}
      >
        {label}
        {active ? (
          sortDir === 'asc' ? (
            <ArrowUp className="h-3.5 w-3.5" />
          ) : (
            <ArrowDown className="h-3.5 w-3.5" />
          )
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5 opacity-30" />
        )}
      </button>
    </th>
  );
}
